import {toggleMapDone,setLang,setCur} from './mutations';
let _l = 'CN/';
//http://localhost:8000/?lang=en-US#/Austin
//http://localhost:8000/?lang=cn-ZH#/Austin
const qs = new URLSearchParams(location.search);
const locale = qs.get('locale');
const lang = qs.get('lang');
if(locale === 'zh_CN'){
  _l = 'CN/';
}
if(lang === 'cn-ZH'){
  _l = 'CN/';
}
if(locale === 'en_US'){
  _l = 'EN/';
}
if(lang === 'en-US'){
  _l = 'EN/';
}
const state =  {
  showIdea: true,
  lang: _l === ''? 'EN/':_l,
  cur: 0,
}
const mutations = {
  toggleMapDone,
  setLang,
  setCur
}
export default {
  namespaced:true,
  state,
  mutations
}
